/* ThermEase: bundle picker (snippets/bundle-offers.liquid) and sticky add-to-cart bar (snippets/sticky-atc.liquid) */

if (!customElements.get('bundle-offers')) {
  customElements.define(
    'bundle-offers',
    class BundleOffers extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;

        this.addEventListener('change', (event) => {
          if (event.target.classList.contains('bundle-offer__input')) this.applySelection();
        });

        // Keep the cards in step when the shopper uses the quantity box instead
        this.onQuantityChange = (event) => {
          if (event.target.id === `Quantity-${this.sectionId}`) this.syncFromQuantity();
        };
        document.addEventListener('change', this.onQuantityChange);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          // Prices differ per variant, so swap in the fresh cards and keep the shopper's choice
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event.data || event.data.sectionId !== this.sectionId) return;
            const fresh = event.data.html.getElementById(this.id);
            if (!fresh) return;
            const quantity = this.selectedQuantity();
            this.innerHTML = fresh.innerHTML;
            this.select(quantity);
          });
        }

        this.applySelection();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onQuantityChange);
        if (this.unsubscribe) this.unsubscribe();
      }

      quantityInput() {
        return document.getElementById(`Quantity-${this.sectionId}`) || this.querySelector('[data-bundle-quantity]');
      }

      selectedQuantity() {
        const checked = this.querySelector('.bundle-offer__input:checked');
        return checked ? checked.value : '1';
      }

      select(quantity) {
        const match =
          this.querySelector(`.bundle-offer__input[value="${quantity}"]`) || this.querySelector('.bundle-offer__input');
        if (match) match.checked = true;
        this.applySelection();
      }

      applySelection() {
        const checked = this.querySelector('.bundle-offer__input:checked');
        if (!checked) return;

        const input = this.quantityInput();
        if (input && input.value !== checked.value) {
          input.value = checked.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.showTotal(checked.dataset.total);
      }

      syncFromQuantity() {
        const input = this.quantityInput();
        if (!input) return;
        let total = '';
        this.querySelectorAll('.bundle-offer__input').forEach((option) => {
          option.checked = option.value === input.value;
          if (option.checked) total = option.dataset.total;
        });
        this.showTotal(total);
      }

      showTotal(total) {
        this.querySelectorAll('.bundle-offer').forEach((card) => {
          card.classList.toggle('is-selected', card.querySelector('.bundle-offer__input').checked);
        });
        document.querySelectorAll(`[data-bundle-total="${this.sectionId}"]`).forEach((element) => {
          element.textContent = total || '';
          element.classList.toggle('hidden', !total);
        });
      }
    }
  );
}

if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.button = this.querySelector('.sticky-atc__button');
        if (!this.mainButton || !this.button) return;

        this.button.addEventListener('click', () => {
          if (this.mainButton.hasAttribute('disabled')) {
            this.mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          this.mainButton.click();
        });

        // Show the bar only once the main add-to-cart button has scrolled out of view above the fold
        this.observer = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', scrolledPast);
          this.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
          this.button.tabIndex = scrolledPast ? 0 : -1;
        });
        this.observer.observe(this.mainButton);

        // Mirror the main button's sold-out / unavailable state
        this.mutationObserver = new MutationObserver(() => this.syncState());
        this.mutationObserver.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled'], subtree: true, childList: true, characterData: true });
        this.syncState();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event.data || event.data.sectionId !== this.sectionId) return;
            const freshPrice = event.data.html.getElementById(`StickyAtc-Price-${this.sectionId}`);
            const price = this.querySelector(`#StickyAtc-Price-${this.sectionId}`);
            if (freshPrice && price) price.innerHTML = freshPrice.innerHTML;
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.unsubscribe) this.unsubscribe();
      }

      syncState() {
        const label = this.button.querySelector('.sticky-atc__label');
        const mainLabel = this.mainButton.querySelector('span');
        const disabled = this.mainButton.hasAttribute('disabled');
        this.button.classList.toggle('is-disabled', disabled);
        if (label && mainLabel) label.textContent = mainLabel.textContent.trim();
      }
    }
  );
}
